import React, { FunctionComponent, SVGProps } from 'react';

import { ReactComponent as JoyBuddy } from '../../../assets/icons/buddy-joy.svg';
import { GenericVoidFunction } from '../../types/genericTypes';
import StyledButtonNE from '../StyledButtonNE/StyledButtonNE';

import './styles.scss';

export interface PageHeaderProps {
  PageHeaderImage?: FunctionComponent<SVGProps<SVGSVGElement> & { title?: string }>;
  title?: string;
  description?: string;
  buttonText?: string;
  buttonAction?: GenericVoidFunction;
}

const PageHeader = ({
  PageHeaderImage = JoyBuddy,
  title,
  description,
  buttonText,
  buttonAction,
  children
}: React.PropsWithChildren<PageHeaderProps>) => {
  return (
    <div className="page-header-container">
      <div className="page-header-image-container">
        {PageHeaderImage && <PageHeaderImage className="page-header-image" />}
      </div>
      <div className="page-header-text-container">
        <h2 className="page-header-title">{title}</h2>
        <p className="page-header-description">{description}</p>
      </div>
      {buttonText && (
        <div className="page-header-button-container">
          <StyledButtonNE buttonType="primary" buttonSize="md" action={buttonAction}>
            {buttonText}
          </StyledButtonNE>
        </div>
      )}
      {children && <div>{children}</div>}
    </div>
  );
};

export default PageHeader;
